import styled from "styled-components";

const PageHeaderStyleWrapper = styled.div`
  padding: 100px 0;
  margin-top: 90px;
  background : #131740;

  .breadcrumb_area {
    font-family: "Poppins";

    .breadcrumb_menu {
      text-transform: uppercase;
      display: flex;
      align-items: center;
      font-size: 18px;
      color: #FF06B7;
      .icon {
        color: rgba(255, 255, 255);
        text-decoration: none;
        align-items: center;
        display: flex;
        cursor: pointer;
      }
      span {
        color: rgba(255, 255, 255);
        margin: 0 5px;
        font-size: 12px;
      }
      p{
        color: rgba(255, 255, 255);
        margin: 0;
        font-size: 15px;
        text-transform : capitalize;
      }
      .icon:hover {
        color: #FF06B7;
      }
    }

    .breadcrumb_title {
      color: white;
      text-transform: capitalize;
      font-size: 50px;
      font-weight: 700;
    }
  }

  .breadcrumb_form {
    display: flex;
    align-items: center;
    justify-content: end;

    form {
      position: relative;

      input,
      button {
        background: transparent;
      }

      input {
        width: 380px;
        padding: 11px 50px 11px 20px;
        color: rgba(255, 255, 255, 0.7);
        border: 1px solid rgba(255, 255, 255, 0.3);

        &:focus {
          outline: none;
        }
      }

      button {
        height: 100%;
        width: 50px;
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        top: 50%;
        right: 0;
        font-size: 20px;
        color: rgba(255, 255, 255, 0.7);
        transform: translate(0, -50%);
        border: none;
      }
    }
  }

  @media only screen and (max-width: 991px) {
    .breadcrumb_area {
      .breadcrumb_title{
        font-size: 40px;
      }
    }
  }

  @media only screen and (max-width: 767px) {
    padding: 80px 0;
    .breadcrumb_form {
      justify-content: start;
      margin-top: 40px;

      form {
        width: 100%;
        input {
          width: 100%;
        }
      }
    }
  }
`;

export default PageHeaderStyleWrapper;
